import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { CalculateDuration, GenderHandler, UserTypeHandler } from "../../utility/CommonFunctions";
import ViewDocumentModal from "../Sites/ViewDocumentModal";
import DocumentIcon from "../../components/Icons/DocumentIcon";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import EditIcon from "../../components/Icons/EditIcon";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { saveUserDetails } from "../../store/actions/UserActions";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";
import MainHeading from "../../components/comman/MainHeading";

export default function UserProfile() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [employeeDetail, setEmployeeDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);
  useEffect(() => {
    GetEmployeeDetail();
  }, []);

  const GetEmployeeDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_profile + `?userId=${userDetails?.id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setEmployeeDetail(response?.data);
        dispatch(
          saveUserDetails({
            ...userDetails,
            profilePhoto: response?.data?.profilePhoto,
          })
        );
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.update_profile, { state: { data: data } });
  };

  const uniqueSiteTypes = [
    ...new Set(
      employeeDetail?.usersites?.map((item) => item.site.type).filter(Boolean)
    ),
  ];

  return (
    <>
      <>
        {isLoading && <BgBlurLoader />}
        <div className="content container-fluid">
          <MainHeading title="Profile" showBackButton={true}>
            <button
              className="btn btn-outline-primary d-flex gap-2"
              onClick={() => HandleUpdate(employeeDetail)}
            >
              <EditIcon />
              Edit
            </button>
          </MainHeading>
          <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
            <div className="card-body px-4 py-3">
              <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                <h4 className="fs-5 fw-bold text-black mb-0">
                  General Details
                </h4>
              </div>
              <ul className="row list-unstyled g-4">
                <li className="col-12">
                  <div>
                    <img className="rounded-circle shadow-md border border-3 border-primary" style={{ width: "100px", height: "100px", objectFit: "cover" }}
                      src={
                        employeeDetail?.profilePhoto ||
                        "/assets/img/employee.svg"
                      }
                      alt="Employee Profile"
                      role="button"
                      onClick={() => {
                        if (employeeDetail?.profilePhoto) {
                          handleDocumentClick({ url: employeeDetail?.profilePhoto })
                        }
                      }
                      }
                    />
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Employee Code :-
                    </span>
                    {employeeDetail?.employeeCode || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Name :-</span>
                    {employeeDetail?.name || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Gender :-</span>
                    {GenderHandler(employeeDetail?.gender)}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Email :-</span>
                    {employeeDetail?.email || "--"}
                  </div>
                </li>
                {/* <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>
                      Official Email :-
                    </span>
                    --
                  </p>
                </li> */}
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Contact :-</span>
                    {employeeDetail?.phone || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Date of Birth :-
                    </span>
                    {employeeDetail?.dob
                      ? moment(employeeDetail?.dob).format("DD-MMM-YYYY")
                      : "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Father Name :-
                    </span>
                    {employeeDetail?.userdetail?.fatherName || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Mother Name :-
                    </span>
                    {employeeDetail?.userdetail?.motherName || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Joining Date :-
                    </span>
                    {employeeDetail?.dob
                      ? moment(employeeDetail?.joiningDate).format(
                        "DD-MMM-YYYY"
                      )
                      : "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Blood Group :-
                    </span>
                    {employeeDetail?.bloodGroup || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Status :-</span>
                    {employeeDetail?.status || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Marital Status :-
                    </span>
                    {employeeDetail?.isMarried ? "Married" : "Unmarried"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Skill Type :-
                    </span>
                    {employeeDetail?.skillType}
                  </div>
                </li>

              </ul>
            </div>
          </div>
          <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
            <div className="card-body px-4 py-3">
              <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                <h4 className="fs-5 fw-bold text-black mb-0">Permission</h4>
              </div>
              <ul className="row list-unstyled g-4">
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      OnRoll Company :-
                    </span>
                    {employeeDetail?.Company?.name || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Employee Type :-
                    </span>
                    {UserTypeHandler(employeeDetail?.type)}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Department :-
                    </span>
                    {employeeDetail?.department?.name || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      System Permission :-
                    </span>
                    {employeeDetail?.designation?.name || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Designation Name :-
                    </span>
                    {employeeDetail?.designationName || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Shift :-</span>
                    {employeeDetail?.Shift?.shiftName || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Site Type :-
                    </span>
                    {/* {uniqueSiteTypes.join(", ")}
                     */}
                    {employeeDetail?.assignedSiteType || "--"}
                  </div>
                </li>
                {employeeDetail?.type === 1 &&

                  <li className="col-12 col-md-6 col-lg-4">
                    <div>
                      <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Assigned Office :-</span>
                      <span className="text-capitalize">
                        {employeeDetail?.site?.name || "--"}
                      </span>
                    </div>
                  </li>
                }
              </ul>
              {/* Assignments Section - Lists in Cards */}
              <div className="row g-3">
                {employeeDetail?.type === 1 && (
                  <div className="col-md-6 col-lg-4">
                    <div className="card shadow-md border-light h-100 rounded-3">
                      <div className="card-header bg-light border-bottom py-3 px-3 rounded-top-3">
                        <h5 className="mb-0 fw-bold text-black text-uppercase">Assigned Companies</h5>
                      </div>
                      <div
                        className="card-body p-2"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        <ul className="list-unstyled mb-0">
                          {employeeDetail?.usercompanies?.length > 0 ? (
                            employeeDetail?.usercompanies?.map(
                              (item, index) => (
                                <li
                                  key={item?.id || index}
                                  className="fs-5 mb-2 border-bottom pb-1"
                                >
                                  {item?.Company?.name || "--"}
                                </li>
                              )
                            )
                          ) : (
                            <li className="text-muted">
                              No Companies Assigned
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-6 col-lg-4">
                  <div className="card shadow-md border-light h-100 rounded-3">
                    <div className="card-header bg-light border-bottom py-3 px-3 rounded-top-3">
                      <h5 className="mb-0 fw-bold text-black text-uppercase">Assigned Customer</h5>
                    </div>
                    <div
                      className="card-body p-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      <ul className="list-unstyled mb-0">
                        {employeeDetail?.usercustomers?.length > 0 ? (
                          employeeDetail?.usercustomers?.map(
                            (userSite, index) => (
                              <li
                                key={userSite.id || index}
                                className="fs-5  mb-2 border-bottom pb-1"
                              >
                                {userSite.customer?.name || "--"}
                              </li>
                            )
                          )
                        ) : (
                          <li className="text-muted">
                            No Customers Assigned
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="card shadow-md border-light h-100 rounded-3">
                    <div className="card-header bg-light border-bottom py-3 px-3 rounded-top-3">
                      <h4 className="mb-0 fw-bold text-black text-uppercase">Assigned Sites</h4>
                    </div>
                    <div
                      className="card-body p-2"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      <ul className="list-unstyled mb-0">
                        {employeeDetail?.usersites?.length > 0 ? (
                          employeeDetail?.usersites?.map(
                            (userSite, index) => (
                              <li
                                key={userSite.id || index}
                                className="fs-5 mb-2 border-bottom pb-1"
                              >
                                {userSite.site?.name || "--"}
                              </li>
                            )
                          )
                        ) : (
                          <li className="text-muted">No Sites Assigned</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
            <div className="card-body px-4 py-3">
              <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                <h4 className="fs-5 fw-bold text-black mb-0">
                  Advance Details
                </h4>
              </div>
              <ul className="row list-unstyled g-4">
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>UAN No :-</span>
                    {employeeDetail?.userdetail?.uanNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Aadhar Card No :-
                    </span>
                    {employeeDetail?.userdetail?.aadharNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      PAN Number :-
                    </span>
                    {employeeDetail?.userdetail?.panNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      ESIC Number :-
                    </span>
                    {employeeDetail?.userdetail?.esicNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Insurance Number :-
                    </span>
                    {employeeDetail?.userdetail?.insuranceNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      PF Number :-
                    </span>
                    {employeeDetail?.userdetail?.pfNumber || "--"}
                  </div>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <div>
                    <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                      Driving License No. :-
                    </span>
                    {employeeDetail?.userdetail?.drivingLicenseNumber || "--"}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Current Address
                    </h4>
                  </div>
                  <ul className="row list-unstyled g-4">
                    <li className="col-12 ">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Address:-
                        </span>
                        {employeeDetail?.userdetail?.address || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          State :-
                        </span>
                        {employeeDetail?.userdetail?.state || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>City :-</span>
                        {employeeDetail?.userdetail?.city || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Post Code :-
                        </span>
                        {employeeDetail?.userdetail?.pinCode || "--"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Permanent Address
                    </h4>
                  </div>
                  <ul className="row list-unstyled g-4">
                    <li className="col-12">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Address:-
                        </span>
                        {employeeDetail?.userdetail?.permanentAddress || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          State :-
                        </span>
                        {employeeDetail?.userdetail?.permanentState || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>City :-</span>
                        {employeeDetail?.userdetail?.permanentCity || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Post Code :-
                        </span>
                        {employeeDetail?.userdetail?.permanentPinCode || "--"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mt-4">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Bank Details
                    </h4>
                  </div>
                  <ul className="row list-unstyled g-4">
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Account Holder Name :-
                        </span>
                        {employeeDetail?.userdetail?.accountHolderName || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Account Number :-
                        </span>
                        {employeeDetail?.userdetail?.accountNumber || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          IFSC/RTGS Code :-
                        </span>
                        {employeeDetail?.userdetail?.ifscCode || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Bank Name :-
                        </span>
                        {employeeDetail?.userdetail?.bankName || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Branch Name :-
                        </span>
                        {employeeDetail?.userdetail?.branchName || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-6 col-lg-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Branch Address :-
                        </span>
                        {employeeDetail?.userdetail?.branchAddress || "--"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mt-4">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Previous Work
                    </h4>
                  </div>
                  {employeeDetail?.previousworks &&
                    employeeDetail?.previousworks?.length > 0 ? (
                    employeeDetail?.previousworks?.map((item, index) => {
                      return (
                        <ul
                          key={index}
                          className="row list-unstyled border border-1 rounded"
                        >
                          <li className="col-12 col-md-6 col-lg-4">
                            <div>
                              <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                                Company Name :-
                              </span>
                              {item?.companyName}
                            </div>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4">
                            <div>
                              <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                                Designation Name :-
                              </span>
                              {item?.designationName}
                            </div>
                          </li>
                          <li className="col-12 col-md-6 col-lg-4 fs-4">
                            <div>
                              <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                                Duration :-
                              </span>
                              <span className="fw-medium fs-5">
                                {`${moment(item?.fromDate).format(
                                  "DD-MMM-YYYY"
                                )} To 
                                 ${item?.toDate
                                    ? moment(item?.toDate).format("DD-MMM-YYYY")
                                    : "Currently Working"
                                  }`}
                              </span>
                            </div>
                            {CalculateDuration(item?.fromDate, item?.toDate)}
                          </li>
                        </ul>
                      );
                    })
                  ) : (
                    <div className="d-flex justify-content-center">
                      <h4>No work detail found</h4>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-12 col-md-4">
      <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
        <div className="card-body px-4 py-3">
          <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
            <h4 className="fs-5 fw-bold text-black mb-0">AR Approvers</h4>
          </div>
          <ul className="row list-unstyled g-4">
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Name :-</span>
                LOKESH SHARMA (S0036)
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Name"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Department :-</span>
                HR
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Department"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Designation:-</span>
                HR MANAGER
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Designation"
                />
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4">
      <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
        <div className="card-body px-4 py-3">
          <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
            <h4 className="fs-5 fw-bold text-black mb-0">
              Leave And OD Approvers
            </h4>
          </div>
          <ul className="row list-unstyled g-4">
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Name :-</span>
                LOKESH SHARMA (S0036)
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Name"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Department :-</span>
                HR
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Department"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Designation:-</span>
                HR MANAGER
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Designation"
                />
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-4">
      <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
        <div className="card-body px-4 py-3">
          <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
            <h4 className="fs-5 fw-bold text-black mb-0">
              Reimbursement Approvers
            </h4>
          </div>
          <ul className="row list-unstyled g-4">
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Name :-</span>
                LOKESH SHARMA (S0036)
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Name"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Department :-</span>
                HR
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Department"
                />
              </p>
            </li>
            <li className="col-12 ">
              <p>
                <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{fontSize: "12px", letterSpacing: "0.5px"}}>Designation:-</span>
                HR MANAGER
                <input
                  type="text"
                  className="form-control d-none"
                  placeholder="Enter Designation"
                />
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div> */}
            <div className="col-12 col-md-4 mt-4">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Documents
                    </h4>
                  </div>
                  <ul className="row list-unstyled gap-3">
                    {employeeDetail?.documents?.length > 0 ? (
                      employeeDetail?.documents?.map((doc, index) => {
                        return (
                          <li key={index} className="col-12">
                            <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {(doc?.updatedAt || doc?.createdAt) ? moment(doc?.updatedAt || doc?.createdAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                          </li>
                        );
                      })
                    ) : (
                      <div>No Document Found</div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-8 mt-4">
              <div className="card shadow-md border-0 rounded-3 mb-4 h-100">
                <div className="card-body px-4 py-3">
                  <div className="d-flex align-items-center justify-content-between border-bottom pb-3 mb-4">
                    <h4 className="fs-5 fw-bold text-black mb-0">
                      Nominee Details
                    </h4>
                  </div>
                  <ul className="row list-unstyled g-4">
                    <li className="col-12 col-md-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Relation Type :-
                        </span>
                        {employeeDetail?.userdetail?.nomineeRelation || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-4">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Name :-</span>
                        <span className="text-capitalize">
                          {employeeDetail?.userdetail?.nomineeName || "--"}
                        </span>
                      </div>
                    </li>
                    <li className="col-12 col-md-4 ">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Phone No. :-
                        </span>
                        {employeeDetail?.userdetail?.nomineePhone || "--"}
                      </div>
                    </li>
                    <li className="col-12 col-md-4 ">
                      <div>
                        <span className="text-uppercase text-muted fw-semibold d-block mb-1" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
                          Date of Birth :-
                        </span>
                        {(employeeDetail?.userdetail?.nomineeDob &&
                          moment(employeeDetail?.userdetail?.nomineeDob).format(
                            "DD-MMM-YYYY"
                          )) ||
                          "--"}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
